const MOJIBAKE_HINT_RE = /[ÃÂâäåæçéèêëìíîïðñòóôõöùúûüýþÿ�]/;
const CJK_RE = /[\u3400-\u9fff]/;

interface NormalizeAccountNameInput {
  rawName?: string | null;
  username?: string | null;
  walletAddress?: string | null;
}

function repairPotentialMojibake(rawName: string): string {
  if (!rawName || !MOJIBAKE_HINT_RE.test(rawName)) {
    return rawName;
  }

  const bytes = Array.from(rawName).map((char) => char.charCodeAt(0));
  if (bytes.some((code) => code > 0xff)) {
    return rawName;
  }

  try {
    const decoded = new TextDecoder('utf-8').decode(Uint8Array.from(bytes));
    if (!decoded || decoded === rawName) {
      return rawName;
    }
    if (!CJK_RE.test(decoded) && CJK_RE.test(rawName)) {
      return rawName;
    }
    return decoded;
  } catch {
    return rawName;
  }
}

export function normalizeAccountDisplayName(input: NormalizeAccountNameInput): string {
  const repairedName = repairPotentialMojibake(String(input.rawName || '').trim());
  return repairedName || String(input.username || '').trim() || String(input.walletAddress || '').trim();
}
